<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      class="mx-auto c-click"
      @click.native="onClick"
    >
      <div class="c-msg-json">
        <div class="flex-col-left">
          <div>{{ $T('common.registered', { tgt: $T('attributes.event') }) }}</div>
          <div class="flex-row-left c-tile">
            <div class="flex-row c-tile-icon">
              <v-icon color="black" :size="26">calendar_today</v-icon>
            </div>
            <div class="c-tile-title" :class="isBlankTitle ? 'c-title-none' : ''">
              {{ isBlankTitle ? `( ${$T('page.cal.notitle')} )` : event ? event.title : '' }}
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import CacheUtils from '../../utils/CacheUtils';
import AppCalendarUtils from '../../utils/AppCalendarUtils';
import CommunityEventApi from '../../api/communityEvent';

export default {
  props: {
    tid: { type: Number, required: true },
    /*
      export interface TalkMsgForEvent {
        t: TALK_MSG_TYPE.POST;
        eid: number;
      }
    */
    data: { type: Object, required: true },
    maxWidth: { type: Number, required: true },
  },
  data() {
    const w = Math.min(this.maxWidth / 2, 80);
    return {
      event: null,
      serverRequested: false,
    };
  },
  created() {
    (async () => {
      const eid = this.data.eid;

      const p = await CacheUtils.getEvent(eid);
      if (p) {
        this.event = p;
        return;
      }

      const result = await CommunityEventApi.getEvent(eid);
      const event = result.event;
      if (event) {
        CacheUtils.setEvent(event.id, event);
        this.event = event;
      }
      this.serverRequested = true;
    })();
  },
  mounted() {},
  watch: {},
  computed: {
    isBlankTitle() {
      if (!this.event) return false;
      return !this.event.title || this.event.title.trim() == '';
    },
  },
  methods: {
    async onClick() {
      const event = await CacheUtils.getEvent(this.data.eid);
      if (!event) return console.warn(`no event on cache.`);
      this.event = event;
      const calEvent = AppCalendarUtils.toDefaultCalEvent(event);
      this.$store.commit('CAL_UPDATE', {
        item: AppCalendarUtils.toWebCalEvent(calEvent),
        members: [`t${this.tid}`],
      });
    },
  },
};
</script>

<style scoped>
.c-click {
  cursor: pointer;
  cursor: hand;
}
.c-tile {
  padding-top: 5px;
}
.c-tile-icon {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.c-tile-title {
  font-size: 14px;
  font-weight: 600;
}
.c-title-none {
  color: rgba(0, 0, 0, 0.37);
}
</style>
